import { Skeleton } from '@/components/ui/skeleton';

export function ServerStatusSkeleton() {
  return (
    <div className="flex items-center gap-4 p-4 rounded-xl border border-border bg-card/50">
      <Skeleton className="w-3 h-3 rounded-full" />
      <div className="flex flex-col gap-2">
        <Skeleton className="h-4 w-20" />
        <Skeleton className="h-3 w-32" />
      </div>
    </div>
  );
}

export function StaffCardSkeleton() {
  return (
    <div className="p-6 rounded-xl border border-border bg-card">
      <div className="flex flex-col items-center gap-4">
        <Skeleton className="w-24 h-24 rounded-full" />
        <Skeleton className="h-5 w-24" />
        <Skeleton className="h-4 w-16" />
        <Skeleton className="h-3 w-32" />
      </div>
    </div>
  );
}

export function RankCardSkeleton() {
  return (
    <div className="p-6 rounded-xl border border-border bg-card">
      <div className="flex flex-col gap-4">
        <Skeleton className="h-6 w-24" />
        <Skeleton className="h-8 w-32" />
        <div className="space-y-2">
          <Skeleton className="h-3 w-full" />
          <Skeleton className="h-3 w-3/4" />
          <Skeleton className="h-3 w-5/6" />
        </div>
        <Skeleton className="h-10 w-full" />
      </div>
    </div>
  );
}

export function FeatureImageSkeleton() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
      <Skeleton className="aspect-video rounded-xl" />
      <div className="space-y-4">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-3/4" />
      </div>
    </div>
  );
}
